var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ol',{staticClass:"breadcrumbs"},_vm._l((_vm.crumbs),function(crumb,index){return _c('li',{key:index,on:{"click":function($event){return _vm.handleClick(crumb.name)}}},[_vm._v(" "+_vm._s(crumb.text)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }